import {IHttpService} from "angular";
import {UserConfig} from "../../types/UserConfig";
import {CurrentUserService} from "./CurrentUserService";
export class UserService {
    public static id = "userService";
    
    /** @ngInject */
    public constructor(private $http: IHttpService,
                       private userConfig: UserConfig,
                       private currentUserService: CurrentUserService) {
    }

    public async updateContactNumber(phone: string | null): Promise<void> {
        if (phone != null && phone !== "") {
            await this.$http.post(`/tradefloor/api/user/${this.userConfig.id}/phone`, phone);
            this.currentUserService.refreshConfig();
        }
    }

    public async updateFullName(givenName: string, surname?: string): Promise<void> {
        const url = `/tradefloor/api/user/${this.userConfig.id}/full-name`;
        const data = { givenName, surname };
        await this.$http.post(url, data);
        this.currentUserService.refreshConfig();
    }

    public async changeDisplayName(name: string): Promise<void> {
        await this.$http.post("/tradefloor/api/user/name", name);
        this.currentUserService.refreshConfig();
    }
}